import { getFullName } from "@vega-api/custom/utils/user";
import { type DealShortlistItemResponse } from "@vega-api/generated/types/dealShortlistItemResponse";
import { m } from "@vega-core/paraglide/messages";
import { formatMoney } from "@vega-core/utils/formatMoney";
import { ShareTabType } from "@vega-modules/scenes/CoInvestmentsGP/constants/sharePageConstants";

import { type ExportColumnConfig } from "../../../hooks/useTableExport";

export const useProspectsExportColumns = (args?: {
  tableType: ShareTabType;
}): ExportColumnConfig<DealShortlistItemResponse>[] => [
  {
    header: m.coInvestments_prospects_limitedPartner(),
    accessor: (row) => row.limitedPartner.name || "",
  },
  {
    header: m.coInvestments_prospects_approved(),
    accessor: (row) => (row.isApproved ? m.common_yes() : m.common_no()),
  },
  {
    header: m.coInvestments_prospects_tier(),
    accessor: (row) => row.tier || "",
  },
  {
    header: m.coInvestments_prospects_estimatedTicketSizeMin(),
    accessor: (row) =>
      row.estimatedTicketSizeMin ? formatMoney(row.estimatedTicketSizeMin) : "",
  },
  {
    header: m.coInvestments_prospects_estimatedTicketSizeMax(),
    accessor: (row) =>
      row.estimatedTicketSizeMax ? formatMoney(row.estimatedTicketSizeMax) : "",
  },
  {
    header: m.coInvestments_prospects_probabilityWeightedMidPoint(),
    accessor: (row) =>
      row.probabilityWeightedMidPoint
        ? formatMoney(row.probabilityWeightedMidPoint)
        : "",
  },
  {
    header: m.coInvestments_prospects_icgPriority(),
    accessor: (row) => {
      if (row.icgPriority == null) return "";

      return row.icgPriority ? m.common_yes() : m.common_no();
    },
  },
  {
    header: m.coInvestments_prospects_lpSma(),
    accessor: (row) => {
      if (row.lpSma == null) return "";

      return row.lpSma ? m.common_yes() : m.common_no();
    },
  },
  {
    header: m.coInvestments_prospects_organizationChannel(),
    accessor: (row) => row.organizationChannel || "",
  },
  args?.tableType === ShareTabType.Approved
    ? {
        header: m.coInvestments_prospects_opportunityOwner(),
        accessor: (row) => {
          if (!row.relationship) return "";
          const fullName = getFullName(row.relationship.fullName);
          const email = row.relationship.email;

          return `${fullName} (${email})`;
        },
      }
    : {
        header: m.coInvestments_prospects_addedBy(),
        accessor: (row) => {
          if (!row.addedBy) return "";
          const fullName = getFullName(row.addedBy.fullName);
          const email = row.addedBy.email;

          return `${fullName} (${email})`;
        },
      },
  {
    header: m.coInvestments_outreach_notes(),
    accessor: (row) => row.notes || "",
  },
];
